"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _msalBrowser = require("@azure/msal-browser");
var _gatewayVars = require("./gateway-vars");
var _logger = require("./helpers/logger");
var _pkceConfigVars = require("./pkce-config-vars");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// initialise default variables
var _DEFAULT_PKCE_CONFIG_ = _pkceConfigVars.DEFAULT_PKCE_CONFIG_VARS.AUTH,
  OPENID_CALLBACK = _DEFAULT_PKCE_CONFIG_.OPENID_CALLBACK,
  AUTHORITY = _DEFAULT_PKCE_CONFIG_.AUTHORITY,
  SCOPES = _DEFAULT_PKCE_CONFIG_.SCOPES,
  OPENID_POST_LOGOUT_REDIRECT_URI = _DEFAULT_PKCE_CONFIG_.OPENID_POST_LOGOUT_REDIRECT_URI;
var _DEFAULT_PKCE_CONFIG_2 = _pkceConfigVars.DEFAULT_PKCE_CONFIG_VARS.CACHE,
  CACHE_LOCATION = _DEFAULT_PKCE_CONFIG_2.CACHE_LOCATION,
  STORE_AUTH_STATE_IN_COOKIE = _DEFAULT_PKCE_CONFIG_2.STORE_AUTH_STATE_IN_COOKIE;
var _DEFAULT_PKCE_CONFIG_3 = _pkceConfigVars.DEFAULT_PKCE_CONFIG_VARS.GATEWAY,
  IS_GATEWAY_SCOPE_REQUIRED = _DEFAULT_PKCE_CONFIG_3.IS_GATEWAY_SCOPE_REQUIRED,
  GATEWAY_SCOPE_TYPE = _DEFAULT_PKCE_CONFIG_3.GATEWAY_SCOPE_TYPE;
var LOG_LEVEL = _pkceConfigVars.DEFAULT_PKCE_CONFIG_VARS.LOGGING.LOG_LEVEL;
var defaultConfig = {
  clientId: '',
  openIdCallback: OPENID_CALLBACK,
  authority: AUTHORITY,
  scopes: SCOPES,
  openidPostLogoutRedirectUri: OPENID_POST_LOGOUT_REDIRECT_URI,
  isGatewayScopeRequired: IS_GATEWAY_SCOPE_REQUIRED,
  gatewayScopeType: null,
  cacheLocation: CACHE_LOCATION,
  storeAuthStateInCookie: STORE_AUTH_STATE_IN_COOKIE,
  logLevel: LOG_LEVEL
};
var AuthProvider = /*#__PURE__*/function (_PublicClientApplicat) {
  (0, _inherits2["default"])(AuthProvider, _PublicClientApplicat);
  var _super = _createSuper(AuthProvider);
  function AuthProvider(providedConfig) {
    var _this;
    (0, _classCallCheck2["default"])(this, AuthProvider);
    var pkceConfig = _objectSpread(_objectSpread({}, defaultConfig), providedConfig);
    var clientId = pkceConfig.clientId,
      authority = pkceConfig.authority,
      scopes = pkceConfig.scopes,
      isGatewayScopeRequired = pkceConfig.isGatewayScopeRequired,
      openIdCallback = pkceConfig.openIdCallback,
      openidPostLogoutRedirectUri = pkceConfig.openidPostLogoutRedirectUri,
      cacheLocation = pkceConfig.cacheLocation,
      storeAuthStateInCookie = pkceConfig.storeAuthStateInCookie,
      logLevel = pkceConfig.logLevel;
    var gatewayScopeType = pkceConfig.gatewayScopeType;
    // check if gateway scope was required but gateway scope type wasn't provided, set gateway scope type
    if (isGatewayScopeRequired && gatewayScopeType === null) {
      gatewayScopeType = GATEWAY_SCOPE_TYPE;
    }
    var redirectUri = window.location.origin + openIdCallback;
    var postLogoutRedirectUri = window.location.origin + openidPostLogoutRedirectUri;
    var config = {
      auth: {
        clientId: clientId,
        redirectUri: redirectUri,
        authority: authority,
        postLogoutRedirectUri: postLogoutRedirectUri,
        navigateToLoginRequestUrl: false
      },
      cache: {
        cacheLocation: cacheLocation,
        storeAuthStateInCookie: storeAuthStateInCookie
      }
    };
    _this = _super.call(this, config);
    _this.login = _this.login.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePromiseRedirectCallback = _this.handlePromiseRedirectCallback.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isLoggedIn = _this.isLoggedIn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getIdTokenClaims = _this.getIdTokenClaims.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getAccessToken = _this.getAccessToken.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getGatewayAccessToken = _this.getGatewayAccessToken.bind((0, _assertThisInitialized2["default"])(_this));
    _this.signout = _this.signout.bind((0, _assertThisInitialized2["default"])(_this));
    _this.constructSilentRequest = _this.constructSilentRequest.bind((0, _assertThisInitialized2["default"])(_this));
    _this.authParameters = {
      scopes: scopes
    };
    _this.fetchGatewayAccessTokenWhileLogin = _this.fetchGatewayAccessTokenWhileLogin.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isGatewayScopeRequired = isGatewayScopeRequired;
    _this.gatewayScopeType = gatewayScopeType;
    _this.customLogger = (0, _logger.createLogger)(logLevel);
    return _this;
  }
  (0, _createClass2["default"])(AuthProvider, [{
    key: "login",
    value: function () {
      var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var accounts;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.handleRedirectPromise();
            case 2:
              accounts = this.getAllAccounts();
              if (!(accounts.length === 0)) {
                _context.next = 7;
                break;
              }
              this.loginRedirect();
              _context.next = 8;
              break;
            case 7:
              throw new Error('Unable to Login');
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "constructSilentRequest",
    value: function constructSilentRequest(authParameters) {
      if (!this.getAllAccounts().length > 0) {
        this.customLogger.debug({
          file_name: 'auth.js',
          "function": 'constructSilentRequest'
        }, 'unable to get Account Information from cache');
        return null;
      }
      var currentAccountName = this.getAllAccounts()[0].username;
      var currentAccount = this.getAccountByUsername(currentAccountName);
      var silentRequest = {
        scopes: authParameters.scopes,
        account: currentAccount,
        forceRefresh: false
      };
      return silentRequest;
    }
  }, {
    key: "fetchAccessTokenSilent",
    value: function () {
      var _fetchAccessTokenSilent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(authParameters) {
        var silentRequest, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.customLogger.info({
                file_name: 'auth.js',
                "function": 'fetchAccessTokenSilent'
              }, 'fetching access token silently');
              silentRequest = this.constructSilentRequest(authParameters);
              if (silentRequest) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", null);
            case 5:
              _context2.next = 7;
              return this.acquireTokenSilent(silentRequest);
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", response);
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              if (!(_context2.t0 instanceof _msalBrowser.InteractionRequiredAuthError)) {
                _context2.next = 16;
                break;
              }
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'fetchAccessTokenSilent'
              }, 'interaction required');
              return _context2.abrupt("return", this.acquireTokenRedirect(authParameters));
            case 16:
              throw _context2.t0;
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 11]]);
      }));
      function fetchAccessTokenSilent(_x) {
        return _fetchAccessTokenSilent.apply(this, arguments);
      }
      return fetchAccessTokenSilent;
    }()
  }, {
    key: "signout",
    value: function signout() {
      this.customLogger.debug({
        file_name: 'auth.js',
        "function": 'logout'
      }, 'logging out');
      this.logout();
    }
  }, {
    key: "getIdTokenClaims",
    value: function getIdTokenClaims() {
      if (this.getAllAccounts()) {
        this.customLogger.debug({
          file_name: 'auth.js',
          "function": 'getIdTokenClaims'
        }, 'found id token');
        return this.getAllAccounts()[0];
      }
      throw new Error('User isn\'t logged in');
    }
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var authParameters, scopes, response, token;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              authParameters = this.authParameters;
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getAccessToken'
              }, "authParameters".concat(JSON.stringify(authParameters)));
              scopes = authParameters;
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getAccessToken'
              }, "fetching access token with the following scopes: ".concat(JSON.stringify(scopes)));
              _context3.next = 6;
              return this.fetchAccessTokenSilent(scopes);
            case 6:
              response = _context3.sent;
              if (response) {
                _context3.next = 10;
                break;
              }
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getAccessToken'
              }, 'unable to fetch Access Token, initiating User Login');
              return _context3.abrupt("return", this.login());
            case 10:
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getAccessToken'
              }, "fetched access token response: ".concat(JSON.stringify(response)));
              if (response.accessToken) {
                _context3.next = 13;
                break;
              }
              throw new Error('Can\'t construct an AccessTokenResponse.');
            case 13:
              token = {
                accessToken: response.accessToken,
                expiresOn: response.expiresOn,
                scopes: response.scopes,
                idTokenClaims: response.idTokenClaims
              };
              return _context3.abrupt("return", token);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAccessToken() {
        return _getAccessToken.apply(this, arguments);
      }
      return getAccessToken;
    }()
  }, {
    key: "getGatewayAccessToken",
    value: function () {
      var _getGatewayAccessToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var scopes, response, token;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.isGatewayScopeRequired) {
                _context4.next = 14;
                break;
              }
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getAccessToken'
              }, 'fetching gateway access token');
              if (this.gatewayScopeType === _gatewayVars.GATEWAY_SCOPES_TYPES.PRODUCTION) {
                scopes = {
                  scopes: [_gatewayVars.GATEWAY_SCOPES.PRODUCTION_GATEWAY_SCOPE]
                };
              } else if (this.gatewayScopeType === _gatewayVars.GATEWAY_SCOPES_TYPES.NON_PRODUCTION) {
                scopes = {
                  scopes: [_gatewayVars.GATEWAY_SCOPES.NON_PRODUCTION_GATEWAY_SCOPE]
                };
              }
              _context4.next = 5;
              return this.fetchAccessTokenSilent(scopes);
            case 5:
              response = _context4.sent;
              if (response) {
                _context4.next = 9;
                break;
              }
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getGatewayAccessToken'
              }, 'unable to fetch Gateway Access Token, initiating User Login');
              return _context4.abrupt("return", this.login());
            case 9:
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'getAccessToken'
              }, "fetched access token response: ".concat(JSON.stringify(response)));
              if (response.accessToken) {
                _context4.next = 12;
                break;
              }
              throw new Error('Can\'t construct an AccessTokenResponse.');
            case 12:
              token = {
                accessToken: response.accessToken,
                expiresOn: response.expiresOn,
                scopes: response.scopes,
                idTokenClaims: response.idTokenClaims
              };
              return _context4.abrupt("return", token);
            case 14:
              throw new Error("You didn't provide consent for Gateway scopes while logging in. ");
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getGatewayAccessToken() {
        return _getGatewayAccessToken.apply(this, arguments);
      }
      return getGatewayAccessToken;
    }()
  }, {
    key: "handlePromiseRedirectCallback",
    value: function () {
      var _handlePromiseRedirectCallback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(processLogin) {
        var tokenResponse;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.handleRedirectPromise();
            case 2:
              tokenResponse = _context5.sent;
              if (!tokenResponse) {
                _context5.next = 18;
                break;
              }
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'handlePromiseRedirectCallback'
              }, "fetched access token response after interaction at ".concat(new Date().toString()));
              // process login callback - perform actions like chaning the app state to authenticated
              processLogin();
              // fetches Gateway token scopes if required
              if (!(this.isGatewayScopeRequired === true)) {
                _context5.next = 16;
                break;
              }
              if (!(this.gatewayScopeType === _gatewayVars.GATEWAY_SCOPES_TYPES.PRODUCTION)) {
                _context5.next = 11;
                break;
              }
              this.fetchGatewayAccessTokenWhileLogin({
                scopes: [_gatewayVars.GATEWAY_SCOPES.PRODUCTION_GATEWAY_SCOPE]
              });
              _context5.next = 16;
              break;
            case 11:
              if (!(this.gatewayScopeType === _gatewayVars.GATEWAY_SCOPES_TYPES.NON_PRODUCTION)) {
                _context5.next = 15;
                break;
              }
              this.fetchGatewayAccessTokenWhileLogin({
                scopes: [_gatewayVars.GATEWAY_SCOPES.NON_PRODUCTION_GATEWAY_SCOPE]
              });
              _context5.next = 16;
              break;
            case 15:
              throw new Error('Gateway scope env variable was not provided or invalid Gateway scope env was provided.');
            case 16:
              _context5.next = 19;
              break;
            case 18:
              if (tokenResponse === null) {
                // tokenResponse was null, attempt sign in or enter unauthenticated state for app
                this.customLogger.debug({
                  file_name: 'auth.js',
                  "function": 'handlePromiseRedirectCallback'
                }, 'tokenResponse was null, attempt sign in');
                this.login();
              } else {
                this.customLogger.debug({
                  file_name: 'auth.js',
                  "function": 'handlePromiseRedirectCallback'
                }, "tokenResponse was not null but did not have any tokens:".concat(JSON.stringify(tokenResponse)));
              }
            case 19:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handlePromiseRedirectCallback(_x2) {
        return _handlePromiseRedirectCallback.apply(this, arguments);
      }
      return handlePromiseRedirectCallback;
    }()
  }, {
    key: "fetchGatewayAccessTokenWhileLogin",
    value: function () {
      var _fetchGatewayAccessTokenWhileLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(authParameters) {
        var silentRequest, errorCode;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              silentRequest = this.constructSilentRequest(authParameters);
              _context6.next = 4;
              return this.acquireTokenSilent(silentRequest);
            case 4:
              _context6.next = 14;
              break;
            case 6:
              _context6.prev = 6;
              _context6.t0 = _context6["catch"](0);
              errorCode = _context6.t0.errorCode;
              if (!(errorCode === 'no_tokens_found')) {
                _context6.next = 13;
                break;
              }
              this.acquireTokenRedirect(authParameters);
              _context6.next = 14;
              break;
            case 13:
              throw _context6.t0;
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 6]]);
      }));
      function fetchGatewayAccessTokenWhileLogin(_x3) {
        return _fetchGatewayAccessTokenWhileLogin.apply(this, arguments);
      }
      return fetchGatewayAccessTokenWhileLogin;
    }()
  }, {
    key: "isLoggedIn",
    value: function () {
      var _isLoggedIn = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var authParameters, silentRequest;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              authParameters = this.authParameters;
              silentRequest = this.constructSilentRequest(authParameters);
              _context7.next = 5;
              return this.acquireTokenSilent(silentRequest);
            case 5:
              return _context7.abrupt("return", true);
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              if (!(_context7.t0 instanceof _msalBrowser.InteractionRequiredAuthError)) {
                _context7.next = 13;
                break;
              }
              this.customLogger.debug({
                file_name: 'auth.js',
                "function": 'isLoggedIn'
              }, 'signing out since refresh token has expired.');
              return _context7.abrupt("return", this.signout());
            case 13:
              return _context7.abrupt("return", false);
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 8]]);
      }));
      function isLoggedIn() {
        return _isLoggedIn.apply(this, arguments);
      }
      return isLoggedIn;
    }()
  }]);
  return AuthProvider;
}(_msalBrowser.PublicClientApplication);
var _default = AuthProvider;
exports["default"] = _default;